import { Button, CircularProgress, Stack, Dialog, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConsultationCodeSelectField from '../ConsultationCodeSelectField/ConsultationCodeSelectField';
import { updateRequest as updateAppointmentRequest } from 'FRONTEND/reducers/appointmentSlice';
import { useGetConsultationCodesForUserQuery } from 'FRONTEND/utils/backendApi/consultationCodesApi';
import i18n from 'FRONTEND/utils/i18n';


const ChargeAppointmentButton = ({ appointment }) => {
  const dispatch = useDispatch();
  const calendarActorId = useSelector((state) => state.calendar.actorId);
  // Modal management
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: expertConsultationCodes, isLoading, isError } = useGetConsultationCodesForUserQuery(calendarActorId, { skip: !calendarActorId });
  const [selectedCode, setSelectedCode] = useState(null);
  useEffect(() => {
    if (!isError && expertConsultationCodes?.length > 0) {
      const defaultRate = expertConsultationCodes?.find((code) => code.isDefault);
      setSelectedCode(defaultRate || expertConsultationCodes[0]);
    }
  }, [expertConsultationCodes]);

  const handleAddConsultationCode = async() => {
    if (!selectedCode) {
      return;
    }
    dispatch(updateAppointmentRequest({
      originalAppointment: appointment,
      consultationCodeId: selectedCode.id,
    }));
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsModalOpen(true)}
      >
        {i18n._('Charge a fee')}
      </Button>

      {/* MODAL */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <Stack p={2} spacing={2}>
          <Typography variant='h5' fontWeight='600'>
            {i18n._('Choose a fee')}
          </Typography>
          {isLoading && <CircularProgress />}
          {isError && <Typography color='error'>{i18n._('An error occurred while processing your request.')}</Typography>}
          {!isLoading && !isError && (
            <ConsultationCodeSelectField
              calendarActorId={calendarActorId}
              onCodeChange={setSelectedCode}
            />
          )}
          <Button
            variant='contained'
            color='primary'
            sx={{ alignSelf: 'flex-end' }}
            onClick={handleAddConsultationCode}
          >
            {i18n._('Validate')}
          </Button>
        </Stack>
      </Dialog>
    </>
  );
};

export default ChargeAppointmentButton;
